<template>
  <article>
      <h2>About this website</h2>
      <p>I design this website for my portfolio. Not the projects page, this is just a practice. This website created by different tech I know.</p>
      <p>This website used VueJs as main framework, on a ubuntu server and using nginx for reverse proxy server. I generated static html by server side rendering, for better site performance and SEO crawling allowable.</p>
      <p>I also build a Rest API for contact list comments. I can check comments anytime!</p>
      <p>For this website, I create 2 projects - <a href="https://github.com/edmondyip/ChineseFonts">Chinese Fonts</a> & <a href="https://github.com/edmondyip/vue-svg-morpheus">Vue SVG Morpheus</a>. I will try to keep update these projects if i can.</p>
  </article>
</template>

<script>
  export default {
    name: 'About256'
  }
</script>

<style scoped lang="scss">
  article {
      h2 {
        text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/about/About256.vue